module.exports = __webpack_public_path__ + "static/media/truck-gray.56b27fcb.svg";